import React, { Component } from 'react';
import { View, Text, TouchableOpacity, Animated } from 'react-native';
import { inject, observer } from 'mobx-react/native';
import { reaction } from 'mobx';
import { DeviceInfo } from 'qunar-react-native';
import { FILTER_BAR_DATA, FilterBarDataModel } from '../../Constant/filterBarData';
import styles from './style';
import { UiStateInterface } from '../../Store/uiState';
import { RootStoreInterface } from '../../Store/index';
import { qav } from '../../Utils/qav';
import { navigate } from '../../Utils/navigate';
import { Colors } from '@qnpm/q-theme';
import { Card } from '@qnpm/q-design-card';
import OrderList from "../OrderList/store";
import {GuideWeChatStoreInterface} from "../../Store/guideWeChat";

const { scenes:{ baseColor } } = Colors;
const { isIOS, scheme: schemeHead,isWeb, isMini, isNotRn } = DeviceInfo;

interface Props {
    uiStateStore?: UiStateInterface;
    orderList?: OrderList;
    guideWeChat?: GuideWeChatStoreInterface;
    sourceFrom?:string;
    isShowFilterBar?: boolean;
    curBusinessId?: string;
    deviceWidth?: number;
    deviceHeight?: number;

    filterBarBgColor?: string;
    filterBarBgCorner?:number;
    filterBarItemSelectedBgColor?:string;
    filterBarItemSelectedTitleColor?: string;
    filterBarItemUnSelctedBgColor?: string;
    filterBarItemUnSelctedTitleColor?: string;

    selecteFilterItemCallBack?: (filterInfo: { [propName: string]: string }, index: number,isJump: boolean,) => void;
    clickFilterBlankAreaCallBack?: () => void;
    toggleFilterBarShow?(show: boolean): void;
    toggleShowBindNotice?(show: boolean): void;
    resetPage?(id: string): void;
}

@inject((store: RootStoreInterface) => ({
    uiStateStore: store.uiState,
    orderList: store.orderlist,
    guideWeChat: store.guideWeChat,
    sourceFrom:store.uiState.sourceFrom,
    isShowFilterBar: store.uiState.isShowFilterBar,
    curBusinessId: store.uiState.businessId,
    toggleFilterBarShow: store.uiState.toggleFilterBarShow,
    toggleShowBindNotice: store.bindNotice.toggleShowBindNotice,
    resetPage: store.resetPage,
    deviceWidth: store.size.deviceWidth,
    deviceHeight: store.size.deviceHeight
}))
@observer
class FilterBar extends Component<Props> {
    public state = {
        showModal: false,
        wrapperHeight: new Animated.Value(0),
        wrapperOpacity: new Animated.Value(0),
        wrapperHeightPure: 0,
        wrapperOpacityPure: 0
    };
    private modalTimer: any;

    public componentDidMount() {
        const { uiStateStore } = this.props;

        // 点击更多的动画
        reaction(
            () => uiStateStore.isShowFilterBar,
            (isShowFilterBar) => {
                if(isMini){
                    this._wrapperAnimateMini(isShowFilterBar)
                }else{
                    this._wrapperAnimate(isShowFilterBar);
                    if (isShowFilterBar) {
                        // 将要展开
                        clearTimeout(this.modalTimer);
                        this.setState({
                            showModal: true
                        });
                    } else {
                        // 将要折起
                        this.modalTimer = setTimeout(() => {
                            this.setState({
                                showModal: false
                            });
                        }, 150);
                    }
                }
            }
        );
    }

    /**
     *
     * @param isShowFilter 去除动画给微信小程序使用
     */
    public _wrapperAnimateMini = (isShowFilter: boolean) => {
        this.setState({
            wrapperHeightPure: isShowFilter ? this.props.deviceHeight : 0,
            wrapperOpacityPure: isShowFilter ? 0.7 : 0,
            showModal: isShowFilter
        })
    };

    public _wrapperAnimate = (isShowFilter: boolean) => {
        const { wrapperHeight, wrapperOpacity } = this.state;

        Animated.parallel([
            Animated.timing(wrapperHeight, {
                toValue: isShowFilter ? this.props.deviceHeight : 0,
                duration: isShowFilter ? 400 : 100,
                useNativeDriver: false
            }),
            Animated.timing(wrapperOpacity, {
                toValue: isShowFilter ? 0.7 : 0,
                duration: isShowFilter ? 100 : 100,
                useNativeDriver: false
            })
        ]).start();
    };

    public onFilterBarItemTap = (filterInfo: FilterBarDataModel, index: number) => {
        const { title, native,web, ios, android, id: businessId } = filterInfo;
        const { toggleFilterBarShow, toggleShowBindNotice, resetPage, curBusinessId } = this.props;

        toggleFilterBarShow(false);

        if (businessId === curBusinessId) {
            this.props.selecteFilterItemCallBack &&
            this.props.selecteFilterItemCallBack(
                filterInfo,
                index,
                false
            );
            return;
        }
        if (this.props.orderList){
            // 切筛选栏后，默认不支持隐私订单
            this.props.orderList.supportPrivateOrder = false;
        }
        if (this.props.guideWeChat && this.props.uiStateStore){
            this.props.guideWeChat.toggleShowGuideChat(this.props.uiStateStore.statusFilter);
        }
        //  todo web & wx
        if(isWeb && web){
            this.props.selecteFilterItemCallBack &&
            this.props.selecteFilterItemCallBack(
                filterInfo,
                index,
                true
            );
            setTimeout(() => {
                navigate(
                    {
                        isSchema: false,
                        schema: `${schemeHead}`,
                        url:web
                    },
                    () => {}
                );
            }, 200)
        }else if (native || ios || android) {
            const schema = native || (isIOS ? ios : android);
            this.props.selecteFilterItemCallBack &&
            this.props.selecteFilterItemCallBack(
                filterInfo,
                index,
                true
            );
            setTimeout(() => {
                navigate(
                    {
                        isSchema: true,
                        schema: `${schemeHead}://${schema}`
                    },
                    () => {}
                );
            }, 200)
        } else {
            toggleShowBindNotice(false);
            resetPage(businessId);

            this.props.selecteFilterItemCallBack &&
            this.props.selecteFilterItemCallBack(
                filterInfo,
                index,
                false
            );
        }
        qav({
            page: 'order_rn_main',
            module: 'filterBtn',
            path: [
                {
                    title,
                    position: index
                }
            ],
            operType: 'click',
            source:this.props.sourceFrom,
        });
    };

    public onPressMask = () => {
        const { toggleFilterBarShow } = this.props;
        toggleFilterBarShow(false);
        this.props.clickFilterBlankAreaCallBack && this.props.clickFilterBlankAreaCallBack();
    };

    public render() {
        const { curBusinessId, deviceWidth, deviceHeight } = this.props;

        const { wrapperHeight, wrapperOpacity, showModal, wrapperHeightPure } = this.state;
        // 小程序端不销毁
        return showModal || isMini ? (
            <Animated.View
                style={[
                    styles.filterBarWrapper,
                    {
                        zIndex: showModal ? 100 : -1
                    },
                    // {
                    //     backgroundColor:'rgba(0, 0, 0, 0.7)',
                    //     // opacity:wrapperOpacity
                    // }
                    {
                        backgroundColor: isNotRn ?
                        'rgba(0, 0, 0, 0.7)' :
                        wrapperOpacity.interpolate({
                            inputRange: [0, 1],
                            outputRange: ['rgba(0, 0, 0, 0)', 'rgba(0, 0, 0, 0.7)']
                        })
                    }
                ]}
            >
                <Animated.View
                    style={[
                        styles.animationView,
                        {height: isMini ? wrapperHeightPure : wrapperHeight}
                        // {
                        //     height: wrapperHeight.interpolate({
                        //         inputRange: [0, 1],
                        //         outputRange: [0, deviceHeight]
                        //     })
                        // }
                    ]}
                >
                    <TouchableOpacity
                        activeOpacity={1}
                        style={styles.filterBarModel}
                        onPress={this.onPressMask}
                        accessible={false}
                    >
                        <View
                            style={{
                                backgroundColor: this.props.filterBarBgColor|| baseColor.background2,
                                // backgroundColor:'white'
                                borderBottomLeftRadius: this.props.filterBarBgCorner || 0,
                                borderBottomRightRadius: this.props.filterBarBgCorner || 0,

                            }}
                        >
                            <Animated.View
                                style={[
                                    styles.filterBar,
                                    {
                                        // opacity: wrapperHeight.interpolate({
                                        //     inputRange: [0, 1],
                                        //     outputRange: [0, 1]
                                        // })
                                    }
                                ]}
                            >
                                {FILTER_BAR_DATA.map((filterInfo, index) => {
                                    const { id, title, tag } = filterInfo;

                                    return (
                                        <View key={id} style={[styles.filterBarItemWrapper, {width: Math.floor((deviceWidth - 14 * 2) / 3)}]}>
                                            <Card radius="small" style={styles.filterBarItemInner} backgroundColor = {curBusinessId === id?
                                                    this.props.filterBarItemSelectedBgColor || baseColor.brand:
                                                    this.props.filterBarItemUnSelctedBgColor || baseColor.white
                                            } >
                                                <TouchableOpacity
                                                    activeOpacity={1}
                                                    style={[styles.filterBarItemInner]}
                                                    accessible={false}
                                                    {...global.orderAccessibilityLabel(tag)}
                                                    onPress={() => {
                                                        this.onFilterBarItemTap(filterInfo, index);
                                                        // this.props.selecteFilterItemCallBack &&
                                                        //     this.props.selecteFilterItemCallBack(
                                                        //         filterInfo,
                                                        //         index
                                                        //     );
                                                    }}
                                                >
                                                    <Text
                                                        style={[
                                                            styles.filterBarItemTitle,
                                                            curBusinessId === id
                                                                ? styles.filterBarItemTitleAvtived
                                                                : null,
                                                            {color:curBusinessId === id?
                                                                this.props.filterBarItemSelectedTitleColor || '#00bcd4' :
                                                                this.props.filterBarItemUnSelectedTitleColor || baseColor.text1
                                                                }
                                                        ]}
                                                    >
                                                        {title}
                                                    </Text>
                                                </TouchableOpacity>
                                            </Card>
                                        </View>
                                    );
                                })}
                            </Animated.View>
                        </View>
                    </TouchableOpacity>
                </Animated.View>
            </Animated.View>
        ) : null;
    }
}

export default FilterBar;
